import React from "react";
import CustomSelect from "../common/Select";

const opcionesDiscapacidad = [
  { value: "01", label: "FÍSICA" },
  { value: "02", label: "VISUAL" },
  { value: "03", label: "AUDITIVA" },
  { value: "04", label: "INTELECTUAL" },
  { value: "05", label: "SICOSOCIAL (MENTAL)" },
  { value: "06", label: "SORDOCEGUERA" },
  { value: "07", label: "MULTIPLE" },
  { value: "08", label: "NINGUNA" }
];

function SelectorDiscapacidad({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesDiscapacidad}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Discapacidad"
      error={error}
      required={required}
    />
  );
}

export default SelectorDiscapacidad;